<template>
  <div class="content has-text-centered">
    <p>
      <strong>Sponsored</strong> by <a href="https://www.kulap.io">KULAP.io</a>, The Best Rate Decentralized Exchange | <a target="_blank" href='https://github.com/kulapio/libra-merchant'>Github</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.content {
  padding: 20px;
}
</style>
